import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const FailedIngestionCount = ({ count }) => {
	return (
		<Box
			component='span'
			data-testid='failed-ingestion-count'
			sx={{ display: 'inline-flex', alignItems: 'center' }}
		>
			<Tooltip title={`${count} emails failed to ingest`}>
				<WarningAmberOutlinedIcon color={'warning'} sx={{ height: '20px' }} />
			</Tooltip>
		</Box>
	);
};

FailedIngestionCount.propTypes = {
	count: PropTypes.number.isRequired,
};

export default FailedIngestionCount;
